// SettingsRedirect.js
// Utility component to redirect legacy settings URLs to new consolidated Dashboard tabs
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects from legacy settings routes to new Dashboard tabs.
 * 
 * NEW ROUTES (Phase 3 - UX Streamlining):
 *   /league/:id/settings → /league/:id/dashboard?tab=manage
 *   /league/:id/settings/players → /league/:id/dashboard?tab=manage
 *   /league/:id/tournament-settings → /league/:id/dashboard?tab=manage
 *   
 * LEGACY SUPPORT (still functional but redirect to consolidated pages):
 *   <SettingsRedirect to="settings" tab="members" />
 *   <SettingsRedirect to="tournament-settings" tab="blinds" />
 * 
 * @param {string} to - Target: "settings", "tournament-settings", "dashboard"
 * @param {string} tab - Optional tab parameter
 * @param {string} useDashboard - If true, redirect to dashboard?tab=manage instead
 */
function SettingsRedirect({ to, tab, useDashboard = false }) {
  const { leagueId } = useParams();
  
  // If useDashboard flag is set, redirect to new dashboard manage tab
  if (useDashboard) {
    return <Navigate to={`/league/${leagueId}/dashboard?tab=manage`} replace />;
  }
  
  // For backwards compatibility, still support redirecting to settings pages
  // But we should migrate these to dashboard over time
  const baseUrl = `/league/${leagueId}/${to}`;
  const redirectUrl = tab ? `${baseUrl}?tab=${tab}` : baseUrl;
  
  return <Navigate to={redirectUrl} replace />;
}

export default SettingsRedirect;
